import { isBasicOnboardingDone } from 'src/mentor/helpers/utilityFunctions'

/**
 * Consumer (wellness) onboarding is complete once the basics are in. Personalisation
 * (persona topics, focus areas, "how did you hear about us") is optional and collected in
 * context later; it used to be required here while the onboarding screen only ever wrote the
 * basics, which trapped every new wellness user in a /wellness ↔ /wellness/onboarding loop.
 */
export function hasCompletedConsumerOnboarding(profileData) {
  if (!profileData) {
    return false
  }
  if (profileData?.info?.USER_ON_BOARD) {
    return true
  }
  return isBasicOnboardingDone(profileData)
}
